/* Preserves the Clarity Shopify embed's consentv2 adapter and project ID. */

  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    let recorderStarted = false;
    function loadRecorder() {
      if (recorderStarted) return;
      recorderStarted = true;
      t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i + "?ref=shopify";
      y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
    }

    // Keep consent queued immediately, but leave homepage loading and painting first.
    const homepage = l.body.classList.contains('template-index') && l.getElementById('hero-three-doors');
    if (homepage && !c.Shopify.designMode) {
      const scheduleRecorder = () => {
        if (typeof c.requestIdleCallback === 'function') {
          c.requestIdleCallback(loadRecorder, { timeout: 2000 });
        } else {
          c.setTimeout(loadRecorder, 200);
        }
      };
      if (l.readyState === 'complete') scheduleRecorder();
      else c.addEventListener('load', scheduleRecorder, { once: true });
    } else {
      loadRecorder();
    }

    c.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], error => {
      if (error) {
        console.error("Error loading Shopify features:", error);
        return;
      }

      c[a]('consentv2', {
        ad_Storage: c.Shopify.customerPrivacy.marketingAllowed() ? "granted" : "denied",
        analytics_Storage: c.Shopify.customerPrivacy.analyticsProcessingAllowed() ? "granted" : "denied",
        source: 101,
      });
    });

    l.addEventListener("visitorConsentCollected", function (e) {
      c[a]('consentv2', {
        ad_Storage: e.detail.marketingAllowed ? "granted" : "denied",
        analytics_Storage: e.detail.analyticsAllowed ? "granted" : "denied",
        source: 101,
      });
    });
  })(window, document, "clarity", "script", "yn81acqcj4");
